import React, { Component } from 'react';
import { BsFillCircleFill } from 'react-icons/all';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { AuthState } from '~/store/ducks/auth/types';
import { ApplicationState } from '../../store';
import Item from './Item';
import MenuItem from './MenuItem';

interface StateProps {
  auth: AuthState;
}

type Props = StateProps;

class MainNavigation extends Component<Props> {
  componentDidMount() {}

  render() {
    const { auth } = this.props;

    return (
      <>
        <ul
          id="mainNavigation"
          className="sidebar-menu tree"
          data-widget="tree"
        >
          <Item className="header" label="Menu" />
          <MenuItem
            path={`/${auth?.company?.path_alias_nm}/home/mostrar-informacoes-pessoais`}
            icon={<BsFillCircleFill />}
            label="Mostrar informações pessoais"
          />
          <MenuItem
            path={`/${auth?.company?.path_alias_nm}/home/exportarinformacoes-operacoes`}
            icon={<BsFillCircleFill />}
            label="Exportar informações e operações"
          />
          <MenuItem
            path={`/${auth?.company?.path_alias_nm}/home/eliminacao-anonimizacao`}
            icon={<BsFillCircleFill />}
            label="Eliminação / Anonimização"
          />
          <MenuItem
            path={`/${auth?.company?.path_alias_nm}/home/gerenciar-consentimento`}
            icon={<BsFillCircleFill />}
            label="Gerenciar consentimento"
          />
          <MenuItem
            path={`/${auth?.company?.path_alias_nm}/home/contactdpo`}
            icon={<BsFillCircleFill />}
            label="Solicitar ajuda ao DPO"
          />
        </ul>
      </>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  auth: state.auth,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  // @ts-ignore
  ...bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainNavigation);
